import React from "react";
import { Link } from "react-router-dom";
import f1 from "../assets/a.jpg";
import f2 from "../assets/b.jpg";

const blogs = [
  {
    id: 1,
    image: f1,
    title: "Our first office",
    description:
      "Over the past year, Volosoft has undergone many changes! After months of preparation.",
    link: "/blog-detail",
    readTime: "2 minutes",
  },
  {
    id: 2,
    image: f2,
    title: "Enterprise design tips",
    description:
      "Over the past year, Volosoft has undergone many changes! After months of preparation.",
    link: "/blog-detail",
    readTime: "12 minutes",
  },
  {
    id: 3,
    image: f2,
    title: "Enterprise design tips",
    description:
      "Over the past year, Volosoft has undergone many changes! After months of preparation.",
    link: "/blog-detail",
    readTime: "12 minutes",
  },
];

export default function BlogSection() {
  return (
    <section className="py-36 px-6 max-w-7xl mx-auto">
      <h2 className="text-3xl font-bold mb-6 text-center text-gray-900">
        Latest Blogs
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {blogs.map((blog) => (
          <Link
            key={blog.id}
            to={blog.link}
            className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300 overflow-hidden flex flex-col"
          >
            {/* Image */}
            <div className="relative">
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <span className="absolute bottom-3 right-3 bg-green-600 text-white text-xs px-3 py-1 rounded-full shadow">
                {blog.readTime}
              </span>
            </div>

            {/* Content */}
            <div className="p-6 flex flex-col flex-grow">
              <h3 className="text-lg font-semibold text-gray-900 group-hover:text-green-700 transition">
                {blog.title}
              </h3>
              <p className="text-gray-600 text-sm mt-3 flex-grow">
                {blog.description}
              </p>
              <span className="mt-5 text-green-600 font-medium text-sm">
                Read More →
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
